const faqs = [
  {
    q: "What kind of data do I need to upload?",
    a: "You need a basic inventory file (product name, SKU, quantity, cost price) and a sales file (date, product, quantity sold). These can be exported from almost any POS, billing software, or even a spreadsheet you maintain manually.",
  },
  {
    q: "Is Stock Move only for apparel stores?",
    a: "While it's designed with apparel and fashion retail in mind, Stock Move works well for any product-based retail business including footwear, accessories, home goods, and general merchandise.",
  },
  {
    q: "Do I need a POS system or any software integration?",
    a: "No. Stock Move works entirely with file uploads. If your data is in a CSV or Excel file — regardless of where it came from — you can use it. No API connections, no software installs.",
  },
  {
    q: "Can I upload CSV or Excel files?",
    a: "Yes, both are supported. We accept .csv, .xlsx, and .xls files. If your export comes out in a different format, our team can help you convert it before your first run.",
  },
  {
    q: "Is this difficult to use if I'm not technical?",
    a: "Not at all. Stock Move is designed specifically for store owners and retail managers who are not data analysts. The output is a plain-language action list, not a dashboard full of charts.",
  },
  {
    q: "What do I get after uploading my data?",
    a: "You receive a full inventory health report including: dead stock by product and category, slow-mover analysis, cash blocked by SKU, days cover analysis, and a prioritised clearance and stop-buying list.",
  },
  {
    q: "Do you help interpret the results?",
    a: "Yes. Every report comes with clear action points written in plain language. For the Free Inventory Audit, our team also does a 30-minute walkthrough call to explain the key findings and help you plan your next steps.",
  },
];

export default function FAQSection({ openFaq, setOpenFaq }) {
  return (
    <div className="sm-section-full sm-section-bg" id="faq">
      <div className="sm-section">
        <div className="sm-reveal" style={{ maxWidth: 580 }}>
          <span className="sm-eyebrow">FAQ</span>
          <h2 className="sm-h2">Common questions</h2>
          <p className="sm-h2-sub">
            Everything you need to know before getting started.
          </p>
        </div>

        <div className="sm-faq-list sm-reveal sm-reveal-d1">
          {faqs.map((faq, index) => {
            const isOpen = openFaq === index;

            return (
              <div key={index} className={`sm-faq-item${isOpen ? " open" : ""}`}>
                <button
                  className="sm-faq-q"
                  onClick={() => setOpenFaq(isOpen ? null : index)}
                  type="button"
                >
                  {faq.q}
                  <span className="sm-faq-icon">+</span>
                </button>

                <div className="sm-faq-a">{faq.a}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}